<!--
 * @Description:详情
 * @Date: 2023-04-13 16:13:52
 -->
<template>
  <div class="">
    <el-dialog
      title="详情"
      width="1000px"
      :visible="visible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <div class="risk-box">
        <el-form
          ref="ruleFormRef"
          :model="updateJson"
          label-width="220px"
          class="ruleForm rmgt"
        >
          <el-form-item required label="执行者年龄区间：">
            <el-input
              style="width: 150px;"
              disabled
              :value="updateJson.ageStart"
              placeholder=""
            >
              <span disabled slot="suffix">岁</span>
            </el-input>
            <span class="line"></span>
            <el-input
              style="width: 150px;"
              disabled
              :value="updateJson.ageEnd"
              placeholder=""
            >
              <span disabled slot="suffix">岁</span>
            </el-input>
          </el-form-item>
          <el-form-item required label="执行任务时间：" prop="startTime">
            <div class="task-times">
              <el-time-select
                disabled
                style="width: 150px;"
                required
                v-model="updateJson.startTime"
              ></el-time-select>
              <div><span class="task-line"></span></div>
              <el-time-select
                disabled
                style="width: 150px;"
                required
                v-model="updateJson.endTime"
              ></el-time-select>
              <!-- <div class="default-range">默认范围：00:00–23:59</div> -->
            </div>
          </el-form-item>
          <div style="margin-top: 20px;" class="cut-off-rule"></div>
          <el-form-item label="项目执行人：" v-if="collectionType != 2">
            <div style="display: flex;">
              <div>
                <div class="task-time">
                  <el-form-item prop="selfMonthNumber">
                    <el-input disabled style="width: 150px;" value="1">
                      <span slot="suffix">
                        自然月内
                      </span>
                    </el-input>
                  </el-form-item>
                  <div class="operability">可提交</div>
                  <el-form-item prop="selfMonthNumber">
                    <el-input
                      disabled
                      style="width: 150px;"
                      placeholder="不限"
                      v-model.number="updateJson.selfMonthNumber"
                      clearable
                    >
                      <span slot="suffix">次</span>
                    </el-input>
                  </el-form-item>
                </div>
                <div class="task-time">
                  <el-form-item prop="projectDay">
                    <el-input style="width: 150px;" value="1" disabled>
                      <span slot="suffix">
                        天内
                      </span>
                    </el-input>
                  </el-form-item>
                  <div class="operability">可提交</div>
                  <el-form-item prop="selfDayNumber">
                    <el-input
                      disabled
                      style="width: 150px;"
                      placeholder="不限"
                      v-model.number="updateJson.selfDayNumber"
                      clearable
                    >
                      <span slot="suffix">次</span>
                    </el-input>
                  </el-form-item>
                </div>
              </div>
              <!-- <div class="default">
                <div class="default-range">默认范围：0-999次</div>
                <div class="default-range marg20">默认范围：0-100次</div>
              </div> -->
            </div>
          </el-form-item>
          <div class="cut-off-rule" v-if="collectionType != 2"></div>
          <el-form-item label="被分享人：" v-if="collectionType != 1">
            <div style="display: flex;">
              <div>
                <div class="task-time">
                  <el-form-item prop="sharerMonth">
                    <el-input style="width: 150px;" value="1" disabled>
                      <span slot="suffix">
                        自然月内
                      </span>
                    </el-input>
                  </el-form-item>
                  <div class="operability">可提交</div>
                  <el-form-item prop="shareMonthNumber">
                    <el-input
                      disabled
                      style="width: 150px;"
                      placeholder="不限"
                      v-model.number="updateJson.shareMonthNumber"
                      clearable
                    >
                      <span slot="suffix">次</span>
                    </el-input>
                  </el-form-item>
                </div>
                <div class="task-time">
                  <el-form-item prop="sharerDay">
                    <el-input style="width: 150px;" value="1" disabled>
                      <span slot="suffix">
                        天内
                      </span>
                    </el-input>
                  </el-form-item>
                  <div class="operability">可提交</div>
                  <el-form-item prop="shareDayNumber">
                    <el-input
                      disabled
                      style="width: 150px;"
                      placeholder="不限"
                      v-model.number="updateJson.shareDayNumber"
                      clearable
                    >
                      <span slot="suffix">次</span>
                    </el-input>
                  </el-form-item>
                </div>
              </div>
              <!-- <div class="default">
                <div class="default-range">默认范围：0-999次</div>
                <div class="default-range marg20">默认范围：0-100次</div>
              </div> -->
            </div>
          </el-form-item>
          <div class="cut-off-rule" v-if="collectionType != 1"></div>
          <el-form-item
            required
            prop="intervalTime"
            label="任务最低间隔时间："
            v-if="collectionType == 1"
          >
            <div class="task-min-time">
              <el-input
                style="width: 150px;"
                v-model.number="updateJson.intervalTime"
                clearable
                disabled
              >
                <span slot="suffix">分钟</span>
              </el-input>
              <span class="task-min-time-tip">
                注：当前任务提交时间与下个任务开始时间的间隔，
                <br />
                &emsp;&emsp;请根据企业实际情况进行调整
              </span>
              <!-- <div class="task-min-time-default">默认范围：0-60分钟</div> -->
            </div>
          </el-form-item>
          <el-form-item>
            <div style="font-size: 13px;margin-left: 40px;">
              <p>注：1. 您可根据实际执行要求修改风控信息</p>
              <p style="margin-left: 30px;">
                2.第一次修改后将会立即生效，此后修改新的风控标准将于次日
                <span style="color: red;">00:00</span>
                生效
              </p>
            </div>
          </el-form-item>
        </el-form>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {};
  },
  props: {
    visible: Boolean,
    updateJson: Object,
    collectionType: Number
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    updateJson() {
      this.$nextTick(() => {
        this.$refs.ruleFormRef.clearValidate();
      });
    }
  },
  //方法集合
  methods: {
    confirm() {
      this.$emit('update:visible', false);
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped lang="scss">
.ruleForm {
  padding: 0;
}

.risk-tips {
  color: #9d9d9d;
  font-size: 13px;
  margin-bottom: 40px;
}

.note-s1 {
  margin-left: 30px;
  color: #9d9d9d;
  font-size: 13px;
}

.distance {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.check {
  position: absolute;
  right: 30.68%;
}

.line {
  width: 16px;
  height: 1px;
  background: #dedede;
  margin: 0 25px;
  display: inline-block;
}

.task-line {
  width: 16px;
  height: 1px;
  background: #dedede;
  margin: 0 30px;
  display: inline-block;
}

.task-times {
  display: flex !important;
}

.task-time {
  display: flex !important;
  margin-bottom: 20px;
}

.cut-off-rule {
  width: 800px;
  height: 1px;
  background: #dedede;
  margin-bottom: 20px;
  margin-top: -10px;
}

.operability {
  margin: 0 20px;
  font-size: 13px;
}

.tip-text {
  text-align: center;
}

.default {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.default-range {
  margin-left: 100px;
}

.marg20 {
  margin-bottom: 20px;
}

.task-min-time {
  display: flex;
  align-items: center;

  &-tip {
    display: inline-block;
    line-height: 18px;
    margin-left: 20px;
    font-size: 13px;
  }

  &-default {
    margin-left: 18px;
  }
}
</style>
